import { useUnit } from 'effector-react'

import {
  $totalCountOfTickets,
  getTickets,
  ticketsListMounted,
  $tickets,
} from './model'
import { TicketsRequest } from './types'

export const useTicketsList = () => {
  const tickets = useUnit($tickets)
  const loading = useUnit(getTickets.pending)
  const totalCountOfTickets = useUnit($totalCountOfTickets)

  const onChangeTicketsList = ({}: TicketsRequest) => {
    ticketsListMounted({})
  }

  return {
    tickets,
    totalCountOfTickets,
    loading,
    onChangeTicketsList,
  }
}
